export default __webpack_public_path__ + "static/7_24-c59ebedd8b5ad4dfc6a9a76f9d15e8be.png";